import React from "react";
import Patient from "../../Components/Admin/Patient/Patient";

const AdminPatientPage = () => {
  return (
    <div className="p-5">
      <Patient />
    </div>
  );
};

export default AdminPatientPage;
